import * as tslib_1 from "tslib";
import { isValidAddress, isValidAddressDomain } from '../utils/smtpAddress';
/* tslint:disable:forbid-import */
// OutlookWeb:24136
import { action, observable } from 'mobx';
/* tslint:enable:forbid-import */
import { observer } from 'mobx-react';
import { IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { FocusZone } from 'office-ui-fabric-react/lib/FocusZone';
import { List } from 'office-ui-fabric-react/lib/List';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { assertNever } from 'owa-assert';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-options-strings';
import { trace } from 'owa-trace';
import * as React from 'react';
import { Selection, SelectionMode, SelectionZone, } from 'office-ui-fabric-react/lib/Selection';
var styles = require('./EditSendersAndDomains.scss');
var classNames = require('classnames/bind');
export var EditSendersAndDomainsMode;
(function (EditSendersAndDomainsMode) {
    EditSendersAndDomainsMode[EditSendersAndDomainsMode["EmailAddressOnly"] = 0] = "EmailAddressOnly";
    EditSendersAndDomainsMode[EditSendersAndDomainsMode["DomainOnly"] = 1] = "DomainOnly";
    EditSendersAndDomainsMode[EditSendersAndDomainsMode["EmailAddressAndDomain"] = 2] = "EmailAddressAndDomain";
})(EditSendersAndDomainsMode || (EditSendersAndDomainsMode = {}));
var ValidationResult;
(function (ValidationResult) {
    ValidationResult[ValidationResult["OK"] = 0] = "OK";
    ValidationResult[ValidationResult["InvalidAddress"] = 1] = "InvalidAddress";
    ValidationResult[ValidationResult["InvalidAddressOrDomain"] = 2] = "InvalidAddressOrDomain";
    ValidationResult[ValidationResult["InvalidDomain"] = 3] = "InvalidDomain";
    ValidationResult[ValidationResult["IsSelf"] = 4] = "IsSelf";
})(ValidationResult || (ValidationResult = {}));
var EditSendersAndDomains = /** @class */ (function (_super) {
    tslib_1.__extends(EditSendersAndDomains, _super);
    function EditSendersAndDomains(props) {
        var _this = _super.call(this, props) || this;
        _this.editItemState = null;
        _this.newItemState = { errorMessage: null, value: null };
        _this.selection = null;
        _this.renderListItem = function (item, index) {
            var isEdit = _this.editItemState && _this.editItemState.index === index;
            var isSelected = _this.selection.isIndexSelected(index);
            return (React.createElement("div", { "data-selection-index": index, key: index, "data-is-focusable": !isEdit, "data-selection-disabled": isEdit }, isEdit
                ? _this.renderEditListItem(item, index)
                : _this.renderViewListItem(item, index, isSelected)));
        };
        _this.renderViewListItem = function (item, index, isSelected) {
            var itemClassName = classNames(styles.viewListItemCell, isSelected && styles.viewListItemCellSelected);
            return (React.createElement("div", { className: itemClassName, "data-is-focusable": true, key: index, onKeyDown: _this.onViewListItemTextFieldKeyDown }, item.key));
        };
        _this.renderEditListItem = function (item, index) {
            _this.selection.setChangeEvents(false);
            return (React.createElement("div", { key: index, "data-is-focusable": false },
                React.createElement(TextField, { "data-is-focusable": false, className: styles.textField, onBlur: function () { return _this.onEditItemTextFieldBlur(index); }, onChanged: _this.onEditItemTextFieldChanged, onFocus: _this.moveEditItemTextFieldCaretToEnd, onKeyDown: function (event) { return _this.onEditItemTextFieldKeyDown(event, index); }, ref: function (input) {
                        input && _this.shouldSetFocusInEditListItemTextField() && input.focus();
                    }, value: _this.editItemState.value }),
                _this.editItemState.errorMessage && (React.createElement(MessageBar, { isMultiline: false, messageBarType: MessageBarType.error }, _this.editItemState.errorMessage))));
        };
        _this.onAddNewItemButtonClicked = function () {
            if (_this.isDuplicate(_this.newItemState.value)) {
                _this.newItemState.value = '';
                return;
            }
            var result = _this.validateSenderOrDomain(_this.newItemState.value);
            if (result == 0 /* OK */) {
                var sendersAndDomains = _this.props.items.slice(0);
                sendersAndDomains.unshift(_this.newItemState.value.trim());
                _this.props.onItemsChanged(sendersAndDomains);
                _this.newItemState.value = '';
            }
            else {
                _this.setNewItemTextFieldErrorMessage(_this.validationErrorMessage(result));
            }
        };
        _this.onEditItemTextFieldBlur = function (index) {
            var result = _this.validateSenderOrDomain(_this.editItemState.value);
            if (result == 0 /* OK */) {
                var sendersAndDomains = _this.props.items.slice(0);
                sendersAndDomains.splice(index, 1, _this.editItemState.value.trim());
                _this.props.onItemsChanged(sendersAndDomains);
                _this.editItemState = null;
                _this.selection = null;
            }
            else {
                _this.setEditItemTextFieldErrorMessage(_this.validationErrorMessage(result));
            }
        };
        _this.resetSelectionOnNextRender = function () {
            _this.selection = null;
        };
        _this.resetSelection = function (items) {
            _this.selection = new Selection({
                onSelectionChanged: function () {
                    if (_this.hasMounted) {
                        _this.forceUpdate();
                    }
                },
                getKey: function (item, index) { return index.toString(); },
            });
            var itemsWithKey = items.map(function (item) {
                return { key: item };
            });
            _this.selection.setItems(itemsWithKey, false);
        };
        _this.onEditItemTextFieldChanged = function (newValue) {
            _this.clearEditItemTextFieldErrorMessage();
            _this.editItemState.value = newValue;
        };
        _this.onEditItemTextFieldKeyDown = function (event, index) {
            switch (event.keyCode) {
                case 13 /* Enter */:
                    var result = _this.validateSenderOrDomain(_this.editItemState.value);
                    if (result == 0 /* OK */) {
                        var sendersAndDomains = _this.props.items.slice(0);
                        sendersAndDomains.splice(index, 1, _this.editItemState.value.trim());
                        _this.props.onItemsChanged(sendersAndDomains);
                        _this.editItemState = null;
                        _this.resetSelectionOnNextRender();
                    }
                    else {
                        _this.setEditItemTextFieldErrorMessage(_this.validationErrorMessage(result));
                    }
                    break;
                case 27 /* Esc */:
                    event.stopPropagation();
                    _this.editItemState = null;
                    _this.resetSelectionOnNextRender();
                    break;
                default:
                    break;
            }
        };
        _this.onEditListItemButtonClicked = function () {
            if (_this.selection.count != 1) {
                throw new Error('onEditListItemButtonClicked with selected items count != 1');
            }
            var item = _this.selection.getItems()[0];
            var index = _this.props.items.indexOf(item.key);
            _this.editItemState = {
                value: item.key,
                index: index,
                errorMessage: null,
            };
        };
        _this.onDeleteListItemButtonClicked = function () {
            var sendersAndDomains = _this.props.items.slice(0);
            _this.selection.getSelection().forEach(function (item) {
                var index = sendersAndDomains.indexOf(item.key);
                if (index !== -1) {
                    sendersAndDomains.splice(index, 1);
                }
            });
            _this.props.onItemsChanged(sendersAndDomains);
            _this.resetSelectionOnNextRender();
        };
        _this.onItemInvoked = function (invokedItem) {
            if ((_this.editItemState && _this.editItemState.errorMessage) ||
                _this.newItemState.errorMessage) {
                return;
            }
            var index = _this.props.items.indexOf(invokedItem.key);
            if (index !== -1) {
                _this.selection.setAllSelected(false);
                _this.editItemState = {
                    value: invokedItem.key,
                    index: index,
                    errorMessage: null,
                };
            }
        };
        _this.onNewItemTextFieldChanged = function (text) {
            _this.clearNewItemTextFieldErrorMessage();
            _this.newItemState.value = text;
        };
        _this.onNewItemTextFieldFocus = function () {
            _this.selection.setAllSelected(false);
        };
        _this.onNewItemTextFieldKeyDown = function (event) {
            switch (event.keyCode) {
                case 13 /* Enter */:
                    if (_this.newItemState.value && _this.newItemState.value.length > 0) {
                        var result = _this.validateSenderOrDomain(_this.newItemState.value);
                        if (result == 0 /* OK */) {
                            _this.onAddNewItemButtonClicked();
                        }
                        else {
                            _this.setNewItemTextFieldErrorMessage(_this.validationErrorMessage(result));
                        }
                    }
                    break;
                case 27 /* Esc */:
                    event.stopPropagation();
                    break;
                default:
                    break;
            }
        };
        _this.onViewListItemTextFieldKeyDown = function (event) {
            switch (event.keyCode) {
                case 8 /* Backspace */:
                case 46 /* Delete */:
                    _this.onDeleteListItemButtonClicked();
                    break;
                default:
                    break;
            }
        };
        _this.moveEditItemTextFieldCaretToEnd = function (event) {
            var tempValue = event.target.value;
            event.target.value = '';
            event.target.value = tempValue;
        };
        _this.newItemTextFieldPlaceHolderText = function () {
            switch (_this.props.mode) {
                case 1 /* DomainOnly */:
                    return strings.options_common_addDomainPlaceholder;
                case 2 /* EmailAddressAndDomain */:
                    return strings.options_common_addSenderOrDomainPlaceholder;
                case 0 /* EmailAddressOnly */:
                    return strings.options_common_addSenderPlaceholder;
                default:
                    return assertNever(_this.props.mode);
            }
        };
        _this.isSelf = function (smtpAddress) {
            var sessionSettings = getUserConfiguration().SessionSettings;
            var userEmailAddress = sessionSettings.UserEmailAddress;
            var lowerCaseSmtpAddress = smtpAddress.toLowerCase();
            if (!userEmailAddress) {
                trace.error('User email address from session data is null.');
            }
            return (userEmailAddress.toLowerCase() === lowerCaseSmtpAddress ||
                (sessionSettings.UserProxyAddresses &&
                    sessionSettings.UserProxyAddresses.some(function (address) { return address.toLowerCase() === lowerCaseSmtpAddress; })));
        };
        _this.setEditItemTextFieldErrorMessage = function (message) {
            _this.editItemState.errorMessage = message;
            _this.forceUpdate();
        };
        _this.setNewItemTextFieldErrorMessage = function (message) {
            _this.newItemState.errorMessage = message;
        };
        _this.clearEditItemTextFieldErrorMessage = function () {
            _this.editItemState.errorMessage = null;
            _this.forceUpdate();
        };
        _this.clearNewItemTextFieldErrorMessage = function () {
            _this.newItemState.errorMessage = null;
        };
        _this.validateSenderOrDomain = function (text) {
            var trimmedText = text.trim();
            switch (_this.props.mode) {
                case 1 /* DomainOnly */:
                    return _this.validateDomain(trimmedText);
                case 0 /* EmailAddressOnly */:
                    return _this.validateEmailAddress(trimmedText);
                case 2 /* EmailAddressAndDomain */:
                    if (_this.validateEmailAddress(trimmedText) == 0 /* OK */ ||
                        _this.validateDomain(trimmedText) == 0 /* OK */) {
                        return 0 /* OK */;
                    }
                    else {
                        return 2 /* InvalidAddressOrDomain */;
                    }
                default:
                    return assertNever(_this.props.mode);
            }
        };
        _this.validateEmailAddress = function (text) {
            if (_this.isSelf(text)) {
                return 4 /* IsSelf */;
            }
            return isValidAddress(text) ? 0 /* OK */ : 1 /* InvalidAddress */;
        };
        _this.validateDomain = function (text) {
            return isValidAddressDomain(text) ? 0 /* OK */ : 3 /* InvalidDomain */;
        };
        _this.validationErrorMessage = function (result) {
            switch (result) {
                case 0 /* OK */:
                    throw new Error('validationErrorMessage called for OK');
                case 1 /* InvalidAddress */:
                    return strings.options_common_invalidAddressError;
                case 2 /* InvalidAddressOrDomain */:
                    return strings.options_common_invalidAddressOrDomainError;
                case 3 /* InvalidDomain */:
                    return strings.options_common_invalidDomainError;
                case 4 /* IsSelf */:
                    return strings.options_common_invalidIsSelfError;
                default:
                    return assertNever(result);
            }
        };
        _this.resetSelection(_this.props.items);
        return _this;
    }
    EditSendersAndDomains.prototype.componentDidMount = function () {
        this.hasMounted = true;
    };
    EditSendersAndDomains.prototype.componentWillUpdate = function (nextProps, nextState) {
        if (!this.selection) {
            this.resetSelection(nextProps.items);
        }
    };
    EditSendersAndDomains.prototype.render = function () {
        var itemsWithKey = this.props.items.map(function (item) {
            return { key: item };
        });
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(IconButton, { className: styles.editListItemButton, "data-is-focusable": true, disabled: this.selection.count !== 1, iconProps: { iconName: "Edit" /* Edit */ }, onClick: this.onEditListItemButtonClicked, styles: {
                        rootDisabled: styles.disabledButton,
                    }, title: strings.options_common_editEmailAddressOrDomainButtonTitle }),
                React.createElement(IconButton, { className: styles.iconButton, "data-is-focusable": true, disabled: !this.selection.count || this.selection.count === 0, iconProps: { iconName: "Delete" /* Delete */ }, onClick: this.onDeleteListItemButtonClicked, styles: {
                        rootDisabled: styles.disabledButton,
                    }, title: strings.options_common_removeEmailAddressOrDomainButtonTitle })),
            React.createElement("div", { className: styles.outerContainer },
                React.createElement("div", { className: styles.textFieldAndListContainer },
                    React.createElement("div", null,
                        React.createElement(TextField, { className: styles.textField, onChanged: this.onNewItemTextFieldChanged, onFocus: this.onNewItemTextFieldFocus, onKeyDown: this.onNewItemTextFieldKeyDown, placeholder: this.newItemTextFieldPlaceHolderText(), value: this.newItemState.value || '' })),
                    this.newItemState.errorMessage && (React.createElement(MessageBar, { isMultiline: false, messageBarType: MessageBarType.error, onDismiss: this.clearNewItemTextFieldErrorMessage }, this.newItemState.errorMessage)),
                    React.createElement(FocusZone, null,
                        React.createElement(SelectionZone, { onItemInvoked: this.onItemInvoked, selection: this.selection, selectionMode: SelectionMode.multiple },
                            React.createElement("div", { className: styles.listItemContainer, "data-is-scrollable": true },
                                React.createElement(List, { items: itemsWithKey, onRenderCell: this.renderListItem }))))),
                React.createElement(PrimaryButton, { text: strings.options_common_addButtonLabel, "data-is-focusable": true, disabled: !this.newItemState.value || this.newItemState.value.length === 0, onClick: this.onAddNewItemButtonClicked, className: styles.addNewItemButton }))));
    };
    EditSendersAndDomains.prototype.shouldSetFocusInEditListItemTextField = function () {
        // only set focus when initially displaying the text field and not
        // when there is an error message displayed - otherwise focus is trapped
        // in the text field when there is an error message
        return !this.editItemState.errorMessage;
    };
    EditSendersAndDomains.prototype.isDuplicate = function (text) {
        // Assume both local part and domain are case-insensitive
        var lowerCaseText = text.toLowerCase();
        return this.props.items.some(function (sender) { return sender.toLowerCase() === lowerCaseText; });
    };
    tslib_1.__decorate([
        observable
    ], EditSendersAndDomains.prototype, "editItemState", void 0);
    tslib_1.__decorate([
        observable
    ], EditSendersAndDomains.prototype, "newItemState", void 0);
    tslib_1.__decorate([
        observable
    ], EditSendersAndDomains.prototype, "selection", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "onAddNewItemButtonClicked", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "onEditItemTextFieldBlur", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "resetSelectionOnNextRender", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "resetSelection", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "onEditItemTextFieldChanged", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "onEditItemTextFieldKeyDown", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "onEditListItemButtonClicked", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "onDeleteListItemButtonClicked", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "onItemInvoked", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "onNewItemTextFieldChanged", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "setEditItemTextFieldErrorMessage", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "setNewItemTextFieldErrorMessage", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "clearEditItemTextFieldErrorMessage", void 0);
    tslib_1.__decorate([
        action
    ], EditSendersAndDomains.prototype, "clearNewItemTextFieldErrorMessage", void 0);
    EditSendersAndDomains = tslib_1.__decorate([
        observer
    ], EditSendersAndDomains);
    return EditSendersAndDomains;
}(React.Component));
export { EditSendersAndDomains };
//# sourceMappingURL=EditSendersAndDomains.js.map